import { useAtomValue } from "jotai";
import { useState } from "react";
import { Nav } from "rsuite";

import {
  FormBuilder,
  FormBuilderField,
} from "../../types/FormBuilderInterfaces";
import GCLogo from "../../assets/img/growthcloud/growthcloud_wordmark.svg";
import SettingsTab from "./CustomizationTab/SettingsTab/SettingsTab";
import StylesTab from "./CustomizationTab/StylesTab/StylesTab";
import BuildTab from "./CustomizationTab/BuildTab/BuildTab";
import { FormAvailableFields } from "./FormBuilderDrawer";
import { Prefill } from "../../types/GlobalInterfaces";
import { Module } from "../../types/TenantInterfaces";
import Form from "./CustomizationTab/Form";
import { IsMobileAtom } from "../../App";

interface Props {
  setForm: (fields: { [key: string]: FormBuilderField }, key: string) => void;
  form: FormBuilder;
  prefill?: Prefill;
  selectedFields?: {
    [key: string]: FormBuilderField;
  };
  availableOptions: FormAvailableFields[];
  module?: Module;
}

const FormBuilderCustomization = ({
  setForm,
  form,
  prefill,
  availableOptions,
  module,
}: Props) => {
  const [tab, setTab] = useState<"build" | "styles" | "settings">("build");
  const mobileScreen = useAtomValue(IsMobileAtom);

  return (
    <div className="d-flex w-100">
      <div
        className="d-flex flex-column border-right border-superlight"
        style={{
          boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0.25)",
          minWidth: 370,
          maxWidth: 370,
          minHeight: "calc(100vh - 76px)",
        }}
      >
        <Nav appearance="subtle" justified className="w-100">
          <Nav.Item
            active={tab === "build"}
            className="flex justify-content-center"
            onClick={() => setTab("build")}
          >
            Build
          </Nav.Item>
          <Nav.Item
            active={tab === "styles"}
            className="flex justify-content-center"
            onClick={() => setTab("styles")}
          >
            Styles
          </Nav.Item>
          <Nav.Item
            active={tab === "settings"}
            className="flex justify-content-center"
            onClick={() => setTab("settings")}
          >
            Settings
          </Nav.Item>
        </Nav>
        <div className="px-2 mb-6">
          {tab === "build" && (
            <BuildTab
              form={form}
              setForm={setForm}
              availableOptions={availableOptions}
              prefill={prefill}
            />
          )}
          {tab === "styles" && <StylesTab form={form} setForm={setForm} />}
          {tab === "settings" && <SettingsTab form={form} setForm={setForm} />}
        </div>
      </div>
      <div
        className="d-flex flex-column align-items-center justify-content-center h-100 pt-4 pb-5"
        style={{
          backgroundColor: form?.GeneralStyles?.BackgroundColor || "#ffffff",
          width: mobileScreen ? undefined : "100%",
        }}
      >
        <img
          src={
            form.Header?.DisableGCLogo && form.Header?.Logo
              ? form.Header?.Logo?.PublicURL
              : GCLogo
          }
          style={{ width: 180, marginRight: 50, marginLeft: 10 }}
          className="mb-4"
        />

        <Form form={form} module={module ?? undefined} />
      </div>
    </div>
  );
};

export default FormBuilderCustomization;
